import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from "rxjs";
import {User} from "./user";
import * as fromStore from "../store";
import {Store} from '@ngrx/store';
import {filter, first, switchMap} from 'rxjs/operators';
import {UserSubscriptionType} from "./user-subscription";


@Injectable()
export class UserPlanTypeGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUser)),
          first()
        )
        .subscribe((data: any) => {
          const user: User = data;
          if (user && (user.planType === UserSubscriptionType.PREMIUM || user.planType === UserSubscriptionType.ONE_PRODUCT)) {
            this._router.navigate(['/websites']);
            resolve(false);
            return;
          }

          resolve(true);
        });
    });
  }

}
